import { Vue } from 'vue-class-component'
import CommonFunctions from '@/components/Utility/Common'
import { Menus } from '@/services/MenusDataService'
import SysMenu, { MenuTypePlacementFriendlyType } from '@/types/SysMenu'
import AuthService from '@/services/AuthService'
import router from '@/router'
import MembersDataService from '@/services/MembersDataService'
import SysMember from '@/types/SysMember'
import { admZubPth } from '@/components/Utility/aXdYmZ'
import store from '@/store'
import { Ref } from 'vue-property-decorator'
import { Posts } from '@/services/PostsDataService'

type dataReturnType = {menus: any; error: any; }

export default class theHeader extends Vue {
  $Message: any
  error: any = null
  private menus: SysMenu[] = []
  public items: any[] = []
  private languageValue = 1
  isSearchBoxOpen = false
  searchQuery = ''
  results: string[] = []
  isLoading = false
  debounceTimer: number | null = null
  resultsView = false
  @Ref() searchRef : HTMLElement | string = ''
  @Ref() openSearchRef : HTMLElement | string = ''
  // private menutypes: SysMenuMenuType[] = []
  private currentListSortingOrder = 'sort[0]=menu_position:asc'
  // private subMenuItem: any
  private leftItems = [
    { icon: 'edit_square', text: 'BILLIARDS DAY' },
    { icon: 'edit_square', text: 'DENDANSKEBILLARDUNION.DK' },
    { icon: 'phone_alt', to: '/persondataforordning', text: this.languageValue === 1 ? 'Kontakt' : 'Contact' }
  ]

  private socialIcons = [
    { icon: 'shopping_cart', href: '/kurven', external: false, alt: 'Kurv' },
    { icon: 'contact_support', href: 'https://ddusupport.dk', external: true, alt: 'Support' },
    { icon: 'phone', href: '/kontakt', external: true, alt: 'Kontakt' }
  ]

  readonly name : string = 'theHeader'
  data (): dataReturnType {
    return {
      menus: this.menus,
      error: this.error
    }
  }

  // public navigator (url: string, optionalPath1 = '', optionalPath2 = '', optionalPath3 = '') : string {
  //   return CommonFunctions.navigationRouter(url, optionalPath1, optionalPath2, optionalPath3)
  // }

  handleClickOutside (event:any) {
    const searchElement = this.searchRef as HTMLElement
    if (searchElement && !searchElement.contains(event.target) && !(this.openSearchRef as HTMLElement).contains(event.target)) {
      this.isSearchBoxOpen = false
      this.searchQuery = ''
    }
  }

  public convertToSlug (text : string) : string {
    return CommonFunctions.slugify(text)
  }

  public openSearchBox () {
    this.isSearchBoxOpen = !this.isSearchBoxOpen
  }

  async onSearch (): Promise<void> {
    if (!this.searchQuery.trim()) {
      this.results = []
      return
    }
    this.results = []
    this.isLoading = true

    // simulating api response time
    const apiResponse = await Posts.PostsDataService.getAll()

    const allData = apiResponse.data

    const query = this.searchQuery.toLowerCase()

    this.results = allData.filter((item: any) => {
      const slugMatch = item.indlaeg_slug?.toLowerCase().includes(query)
      const titleMatch = item.indlaeg_versionerings_id?.[0]?.indlaeg_versionering_titel?.toLowerCase().includes(query)
      return slugMatch || titleMatch
    })

    this.isLoading = false
    this.resultsView = true
  }

  selectResult (item: string): void {
    console.log('Selected:', item)
  }

  debouncedSearch (): void {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.resultsView = false
    }

    this.debounceTimer = window.setTimeout(() => {
      this.onSearch()
    }, 300)
  }

  public navigationRouter (url: string, optionalPath1 = '', optionalPath2 = '', optionalPath3 = '') : void {
    console.log(url)
    CommonFunctions.navigationRouter(url, optionalPath1, optionalPath2, optionalPath3)
    // if (url.toLowerCase().includes('http') || url.toLowerCase().includes('www')) {
    //   window.open(url, 'noopener')

    //   return url
    // }
    // if (url === '#') {
    //   return url
    // }
    // if (url === 'club-list') {
    //   this.$router.push('/klubber')

    //   return url
    // }
    // if (url === 'member-list') {
    //   this.$router.push('/medlemmer')

    //   return url
    // }
    // if (url === 'member-registration') {
    //   this.$router.push('/medlemmer/nyt-medlem')

    //   return url
    // }
    // if (url === 'competition-list') {
    //   this.$router.push('/staevner')

    //   return url
    // }
    // if (url === 'event-list') {
    //   this.$router.push('/arrangementer')

    //   return url
    // }
    // if (url === 'sponsor-list') {
    //   this.$router.push('/sponsorer')

    //   return url
    // }
    // if (url === 'news-archive') {
    //   this.$router.push('/nyheder')

    //   return url
    // }
    // if (url === 'ranking-main') {
    //   this.$router.push({ path: '/staevner/ranglister' })

    //   return url
    // }
    // if (url === 'the-calendar') {
    //   this.$router.push({ path: '/kalender' })

    //   return url
    // } if (url === 'tournaments') {
    //   this.$router.push({ name: 'FrontEndTournaments' })
    //   return url
    // } else {
    //   console.log(url)

    //   this.$router.push({ name: 'Pages', params: { pathSlug1: this.convertToSlug(optionalPath1), pathSlug2: this.convertToSlug(optionalPath2), pathSlug3: this.convertToSlug(optionalPath3), slug: url } })

    //   return url
    // }
  }

  public getUserName () : string {
    let retVal = ''
    if (localStorage.getItem('user') !== null) {
      const userString = localStorage.getItem('user')?.toString()
      const userDataObject = (userString !== undefined && userString !== null ? JSON.parse(userString) : null)
      retVal = userDataObject.username
    }
    return retVal
  }

  public async toMemberPortal () : Promise<void> {
    if (localStorage.getItem('user') === null) {
      console.log('ERROR: no user')
      return
    }
    const userString = localStorage.getItem('user')?.toString()
    const userDataObject = (userString !== undefined && userString !== null ? JSON.parse(userString) : null)
    let members: SysMember[] = []
    MembersDataService.getLoginAll(null, `filter[user_id][id]=${Number(userDataObject.id)}&populate[user_id][populate][usrgroup][fields][0]=id`)
      .then((response) => {
        members = response.data

        if (members.length > 1) {
          return this.$Message.danger({ text: 'Fejl: Flere med samme brugernavn' })
        }
        if (members[0].user_id?.usrgroup?.id === 2) {
          return this.$router.push({ name: 'AdminHome' })
        }
        if (members.length === 0) {
          return this.$Message.warning({ text: 'Fejl: Ingen med det brugernavn' })
        }
        console.log(members[0])
        return this.$router.push({ name: 'MemberPortalMain', params: { userSlug: this.convertUserNameToSlug(Number(members[0].id), members[0].user_id.username) } })
      })
      .catch((err) => {
        this.error = err
      })
  }

  public convertUserNameToSlug (id: number, userName: string) : string {
    return id.toString() + '-' + CommonFunctions.slugify(userName)
  }

  public getLink () : string {
    let retVal = ''

    if (localStorage.getItem('user') !== null) {
      const userString = localStorage.getItem('user')?.toString()
      const userDataObject = (userString !== undefined && userString !== null ? JSON.parse(userString) : null)
      retVal = userDataObject.id.toString() + '-' + userDataObject.username.toString().replaceAll(' ', '-')
    }
    return retVal
  }

  public getTopMenu () : SysMenu[] {
    return this.menus
      .filter((element) => { return (element.menu_status === true) })
      .filter((element) => { return (element.menu_submenu === false) })
      .filter((element) => { return (element.menu_type_id?.menu_type_placering === MenuTypePlacementFriendlyType.Top) })
  }

  public getTopBar (): SysMenu[] {
    const noSubmenu = this.menus.filter((element) => {
      const result = element?.menu_submenu === false
      return result
    })

    const topBarMenus = noSubmenu.filter((element) => {
      const isTopbar = element?.menu_type_id?.menu_type_placering === MenuTypePlacementFriendlyType.Topbar
      return isTopbar
    })

    return topBarMenus
  }

  public subMenu (menuId: number) : SysMenu[] {
    const subMenuTitel: SysMenu[] = []

    for (const subMenuItem of this.menus) {
      if (subMenuItem.menu_submenu_id === menuId && subMenuItem.menu_status === true && subMenuItem.menu_submenu === true) {
        subMenuTitel.push(subMenuItem)
      }
    }
    return subMenuTitel
  }

  public subSubMenu (subMenuId: number) : SysMenu[] {
    const subSubMenuTitel: SysMenu[] = []

    for (const subSubMenuItem of this.menus) {
      if (subSubMenuItem.menu_submenu_id === subMenuId && subSubMenuItem.menu_status === true && subSubMenuItem.menu_submenu === true) {
        subSubMenuTitel.push(subSubMenuItem)
      }
    }

    return subSubMenuTitel
  }

  public subSubSubMenu (subSubMenuId: number) : SysMenu[] {
    const subSubSubMenuTitel: SysMenu[] = []

    for (const subSubSubMenuItem of this.menus) {
      if (subSubSubMenuItem?.menu_submenu_id === subSubMenuId && subSubSubMenuItem?.menu_status === true && subSubSubMenuItem?.menu_submenu === true) {
        subSubSubMenuTitel.push(subSubSubMenuItem)
      }
    }

    return subSubSubMenuTitel
  }

  public async retrieveMenus () : Promise<void> {
    // Menus.MenusDataService.getAll(this.currentListSortingOrder, null, 'filters[menu_status][$eq]=true&filters[menu_type_id][domaene_id][$eq]=1')
    Menus.MenusDataService.getAll()
      .then((response) => {
        this.menus = response.data
        this.$forceUpdate()
      })
      .catch((err) => {
        this.error = err
      })
  }

  public goToMainMenu (menu:any) {
    const url = menu.menu_url

    if (!url) return

    if (/^https?:\/\//i.test(url)) {
      window.open(url, '_blank', 'noopener,noreferrer')
    } else {
      this.$router.push(url)
    }
  }

  public home () : void {
    this.$router.push('/')
  }

  public userLogout () {
    AuthService.logout(true)
  }

  public login () : void {
    router.push({ path: '/medlemsportal/login' })
  }

  // Changes the button to a logout button if false
  public currentlyLoggedIn () : boolean {
    const loggedInStatus = localStorage.getItem('status')
    const loginType = localStorage.getItem('logintype')
    const apiToken = localStorage.getItem('apitoken')
    const userdata = localStorage.getItem('user')

    if (loggedInStatus !== undefined && loggedInStatus !== null && loggedInStatus === true.toString() && loginType !== undefined && loginType !== null && loginType === true.toString() && apiToken !== undefined && apiToken !== null && apiToken.length >= 100 && userdata !== undefined && userdata !== null && !userdata.startsWith('{"id":1,')) {
      const userString = localStorage.getItem('user')?.toString()
      const userDataObject = (userString !== undefined && userString !== null ? JSON.parse(userString) : null)
      // console.log(userDataObject)
      if (userDataObject.id !== 1) {
        store.dispatch('loadStoredState')
        return true
      }
    }
    return false
  }

  public userLoggedIn () {
    return store.state.logintype
  }

  formatDate (isoDate: string): string {
    const date = new Date(isoDate)
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return date.toLocaleDateString('en-US', options)
  }

  extractImgUrl (content: any) {
    const html = content?.indlaeg_versionerings_id?.[content?.indlaeg_versionerings_id.length - 1]?.indlaeg_versionering_indhold ?? ''
    const urls = new Set()

    const combinedRegex = /<img[^>]+src=["']([^"']+\.(?:jpg|jpeg|png|gif|webp|svg))["']|https?:\/\/[^\s"'<>]+?\.(?:jpg|jpeg|png|gif|webp|svg)/gi
    let match

    while ((match = combinedRegex.exec(html)) !== null) {
      urls.add(match[1] || match[0])
    }
    const res = Array.from(urls)[0]
    return res
  }

  public filteredItems : any = []
  public LinksfilteredItems : any = []
  public lastHoveredItem = ''

  startIdx = 0
  endIdx = 4
  pageSize = 4
  currentMenuType = ''

  public get isNextDisabled () {
    const filtered = this.items.filter(
      (ele: any) =>
        ele?.indlaeg_kategori_id?.indlaeg_kategori_titel.toLowerCase() ===
        this.currentMenuType
    )
    return this.endIdx >= filtered.length
  }

  public get isPrevDisabled () {
    return this.startIdx <= 0
  }

  public nextPosts () {
    const filtered = this.items.filter(
      (ele: any) =>
        ele?.indlaeg_kategori_id?.indlaeg_kategori_titel.toLowerCase() ===
        this.currentMenuType
    )

    if (this.endIdx >= filtered.length) {
      return
    }

    this.startIdx += this.pageSize
    this.endIdx = this.startIdx + this.pageSize
    this.filteredItems = filtered.slice(this.startIdx, this.endIdx)
  }

  public prevPosts () {
    if (this.startIdx <= 0) return

    const filtered = this.items.filter(
      (ele: any) =>
        ele?.indlaeg_kategori_id?.indlaeg_kategori_titel.toLowerCase() ===
        this.currentMenuType
    )

    this.startIdx -= this.pageSize
    if (this.startIdx < 0) this.startIdx = 0
    this.endIdx = this.startIdx + this.pageSize
    this.filteredItems = filtered.slice(this.startIdx, this.endIdx)
  }

  public fetchItems (menu_type: string) {
    this.currentMenuType = menu_type.toLowerCase()
    this.startIdx = 0
    this.endIdx = this.pageSize
    this.lastHoveredItem = menu_type
    const filtered = this.items.filter(
      (ele: any) =>
        ele?.indlaeg_kategori_id?.indlaeg_kategori_titel.toLowerCase() ===
        this.currentMenuType
    )
    this.filteredItems = filtered.slice(this.startIdx, this.endIdx)
    return this.filteredItems
  }

  public fetchLinksPosts (menu: any) {
    this.LinksfilteredItems = this.items.filter((ele:any) => ele?.menus_id?.[0]?.id === menu?.id)
    return this.LinksfilteredItems
  }

  goToCategories (categoryType:any) {
    this.$router.push({
      name: 'category',
      params: { categoryType: categoryType }
    })
  }

  public viewPostById (item: any) {
    console.log(item, 'item >>>>>>>>>>')
    this.$router.push({
      name: 'Indlaeg_type',
      params: { indlaeg_type: item?.indlaeg_kategori_id?.indlaeg_kategori_titel, indlaegSlug: item.indlaeg_slug }
    })
  }

  public async getData (): Promise<void> {
    try {
      const response = await Posts.PostsDataService.getAll()
      if (response?.data) {
        this.items = response.data
        this.fetchItems('kegler')
      }
    } catch (error) {
      console.error('Failed to fetch indlaegs data', error)
    }
  }

  async mounted () : Promise<void> {
    this.retrieveMenus()
    this.currentlyLoggedIn()
    this.getData()
    // this.retrieveMenuTypes()
    document.addEventListener('click', this.handleClickOutside)
  }

  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  }
}
